import { ContentLibraryFilters } from "../machines/studentExperience/types"

export const CONTENT_LIBRARY_FILTERS_KEY = "CONTENT_LIBRARY_FILTERS"

// Filters live in the student-experience machine context, which is torn down
// when the student leaves for a lesson or quiz. Persist them for the session so
// the Content Library can restore them when the return URL carries no filters.
export const saveContentLibraryFilters = (filters: ContentLibraryFilters) => {
  sessionStorage.setItem(
    CONTENT_LIBRARY_FILTERS_KEY,
    JSON.stringify({
      level: filters?.level ?? null,
      status: filters?.status ?? null
    })
  )
}

export const getStoredContentLibraryFilters =
  (): ContentLibraryFilters | null => {
    const raw = sessionStorage.getItem(CONTENT_LIBRARY_FILTERS_KEY)

    if (!raw) return null

    try {
      const parsed = JSON.parse(raw)

      return {
        level: typeof parsed?.level === "string" ? parsed.level : null,
        status: typeof parsed?.status === "string" ? parsed.status : null
      }
    } catch {
      return null
    }
  }
